import { Avatar, Box, CircularProgress, Stack, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getLikeDetails } from '../../../service/feed.service';
import Modal from '../../common/Modal';

export default function LikeDetailsModal({ isOpen, handleClose, postId }) {
  const [loading, setLoading] = useState(true);
  // Like data
  const [likeData, setLikeData] = useState([]);

  useEffect(() => {
    const fetchLikes = async () => {
      const res = await getLikeDetails(postId);
      if (res) {
        setLikeData(res);
      }
      setLoading(false);
    };
    fetchLikes();
  }, []);

  return (
    <Modal open={isOpen} onClose={handleClose} title="Like by">
      {loading ? (
        <Box display="flex" justifyContent="center" my={2}>
          <CircularProgress />
        </Box>
      ) : (
        <>
          {likeData.map((like) => (
            <Stack direction="row" spacing={2} alignItems="center" key={like?._id ?? like?.id}>
              <Avatar alt={like.fullName} src={like.profileImage} sx={{ mr: 2 }} />
              <Typography variant="subtitle2" noWrap>
                {like.fullName}
              </Typography>
            </Stack>
          ))}
        </>
      )}
    </Modal>
  );
}

LikeDetailsModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  postId: PropTypes.string
};
